export default __webpack_public_path__ + "static/media/phone-icon.1572a4ea.svg";